export default __webpack_public_path__ + "static/media/ibmq.8896c58a.jpeg";